let $ = require('jquery');
require('./QuickFileUploader.less');
import _ from "underscore";
import {setElementsFromScope, handleDisplayForV2, combineElements} from "../../utilities/selectorHelpers";
import {isPresent} from "../../utilities/general";

// export QuickFileUploader to window
// so it can be referenced in the theme repo
// for external use (ricochet) and internal bundle
window.QuickFileUploader = QuickFileUploader;


// FACTORY
function quickFileUploader(el, options){
  if(el && el.length){
    if(el.data('quick-file-uploader')){
      const qfu = el.data('quick-file-uploader');
      qfu.setOptions(options);
      return qfu;
    }
    else{
      const qfu = new QuickFileUploader(el, options);
      
      return qfu;
    }
  }
}



const elementsMap = {
  fileTextInput: ".qfu-file-text-input",
  fileInput: ".qfu-file-input",
  selectFileBtn: ".qfu-select-file-btn",
  removeBtn: ".qfu-remove-file-btn",
};


function QuickFileUploader(el, opts={}) {
  const self = this;
  $ = opts.$ || $;
  const els = {};
  let options = {};
  let fileMeta = null;

  self.setOptions = setOptions;
  self.getFile = getFile;


  function getFile(){
    return fileMeta;
  }


  setOptions(opts);
  init();

  function init(){
    setElements();
    render();

    bindElements();
  }


  function render(){
    if(isPresent(els.fileTextInput.val())){
      showRemoveBtn();
    }
    else{
      hideRemoveBtn();
    }
  }


  function setElements(){
    setElementsFromScope(els, elementsMap, el);
  }

  function setOptions(opts){
    options = opts;
  }

  function hideRemoveBtn(){
    handleDisplayForV2(els.removeBtn, false);
  }

  function showRemoveBtn(){
    handleDisplayForV2(els.removeBtn, true);
  }

  function bindElements(){
    els.selectFileBtn.on("click", handleSelectBtnClick);
    els.fileInput.on("change", handleFileInputChange);
    els.removeBtn.on("click", handleRemoveBtnClick);
  }

  function handleRemoveBtnClick(e){
    e.preventDefault();
    els.fileInput.val("");
    els.fileTextInput.val("");
    fileMeta = null;
    hideRemoveBtn();
    // check if option available in seperate function and then call option option.afterRemoveFile
    handleRemoveFileOption();
  }

  function handleRemoveFileOption(){
    if(opts.afterRemoveFile){
        removeFileAndCallOption();
    }
  }

  function removeFileAndCallOption(){
      opts.afterRemoveFile();
  }


  function handleFileInputChange(e){
    if(fileApiSupported()){
      fileMeta = e.target.files[0];
      setFileMeta(fileMeta);
      handleReadFileOption();
      insertFileTextToInput();
      showRemoveBtn();
      console.log(fileMeta);
    }
    else{
      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
    }
  }

  function handleReadFileOption(){
    if(opts.afterReadFile && isPresent(fileMeta)){
      readFileAndCallOption();
    }
  }

  function readFileAndCallOption(){
    const reader = new FileReader();
    reader.onload = handleFileReadComplete;
    reader.readAsDataURL(fileMeta); 
  }

  function handleFileReadComplete(e){
    const result = e.target.result;
    opts.afterReadFile(e, result);
  }


  function insertFileTextToInput(){
    els.fileTextInput.val(fileMeta.name);
  }

  function handleSelectBtnClick(e){
    e.preventDefault();
    openNativeFileBrowser();
  }

  function openNativeFileBrowser(){
    els.fileInput.trigger("click");
  }

  function fileApiSupported(){
    return !!(window.File && window.FileReader && window.FileList && window.Blob);
  }

  function setFileMeta(fm){
    els.fileInput.data('file-meta', fm);
    fileMeta = fm;
  }
}

export {quickFileUploader};
export default QuickFileUploader;


// WEBPACK FOOTER //
// ./src/components/QuickFileUploader/QuickFileUploader.js